import ajax from "@common/scripts/ajax";
import { on } from "delegated-events";
import { validateForm } from "@common/scripts/validation";

let stripe;
let elements;

const initializePaymentForm = async (form, type) => {
  stripe = window.Stripe(form.dataset.stripeKey);

  const appearance = {
    labels: "floating",
    theme: "stripe",
    variables: {
      colorPrimary: "#213bc0",
      colorBackground: "#ffffff",
      colorDanger: "#b5134b",
      fontFamily: "Lato, system-ui, sans-serif",
      borderRadius: "8px",
    },
  };

  try {
    const endpoint = form.dataset.paymentEndpoint;

    const data = new FormData();
    data.set("type", type);

    const res = await ajax.post(endpoint, { body: data }).json();

    elements = stripe.elements({ clientSecret: res.clientSecret, appearance });

    const paymentElement = elements.create("payment", {
      layout: "tabs",
    });
    paymentElement.mount("#payment-element");
  } catch (error) {
    console.error(error);
  }
};

const handlePaymentSubmit = async (e) => {
  e.preventDefault();

  const form = e.currentTarget;
  const submitButton = form.querySelector('[type="submit"]');
  const isValid = validateForm(form);

  if (!isValid) {
    return;
  }

  const formData = new FormData(form);

  const billingDetails = {};

  if (document.getElementById("account-information-json")) {
    const json = JSON.parse(document.getElementById("account-information-json").textContent);
    billingDetails.name = `${json["FirstName"]} ${json["LastName"]}`;
    billingDetails.email = json["Email"];
    billingDetails.phone = json["Phone"];
    billingDetails.address = {
      line1: json["Address1"],
      line2: json["Address2"],
      city: json["City"],
      state: json["State"],
    };
  }

  if (!formData.get("SameBilling")) {
    billingDetails.name = `${formData.get("BillingFirstName")} ${formData.get("BillingLastName")}`;
    billingDetails.email = formData.get("BillingEmail");
    billingDetails.phone = formData.get("BillingPhone");
    billingDetails.address = {
      line1: formData.get("BillingAddress1"),
      line2: formData.get("BillingAddress2"),
      city: formData.get("BillingCity"),
      state: formData.get("BillingState"),
    };
  }

  submitButton.disabled = true;
  submitButton.classList.add("is-loading");

  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: "https://ocgov.net",
      payment_method_data: {
        billing_details: billingDetails,
      },
    },
    redirect: "if_required",
  });

  if (error && (error.type === "card_error" || error.type === "validation_error")) {
    showMessage(error.message);
    submitButton.disabled = false;
    submitButton.classList.remove("is-loading");
  } else if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "processing")) {
    // "processing" is the expected status for ACH/bank account payments, which settle asynchronously
    form.submit();
  } else {
    showMessage("An unexpected error occurred.");
    submitButton.disabled = false;
    submitButton.classList.remove("is-loading");
  }
};

function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageContainer.textContent = "";
  }, 4000);
}

const handlePaymentForm = () => {
  const form = document.querySelector(".payment-form");

  if (!form) {
    return;
  }

  form.addEventListener("submit", handlePaymentSubmit);

  initializePaymentForm(form);

  on("change", '[name="PaymentType"]', (e) => {
    initializePaymentForm(form, e.target.value);
  });
};

export default {
  init: () => {
    handlePaymentForm();
  },
};
